// extracted by mini-css-extract-plugin
export var brand = "_2g-9";
export var compact = "_2g-6";
export var extraSmall = "_2g-7";
export var icon = "_2g-0";
export var large = "_2g-4";
export var light = "_2g-1";
export var medium = "_2g-5";
export var outline = "_2g-b";
export var primaryDark = "_2g-a";
export var primaryLight = "_2g-8";
export var primaryModern = "_2g-c";
export var success = "_2g-2";
export var successSolid = "_2g-3";